/**
 * PERSIST-MIGRATIONS
 * Le store complet est persiste dans le localStorage (cf. persistConfig) : un navigateur qui a
 * ouvert l'app avant une bascule de format garde donc l'ancien etat, meme apres deploiement.
 * Chaque migration ci-dessous ne s'execute qu'une fois par navigateur, a la rehydratation.
 */

/**
 * v1 - Attributs de risques au format { id, name } (pendant du script SQL 2026-08-21).
 * L'ancien format etait un tableau de libelles, le libelle servant de cle dans
 * PhysicalRisk.attributes : il devient donc l'id, a l'identique, pour ne perdre aucune valeur.
 */
function migrateRiskAttributes(settings: any) {
  if (!settings || !Array.isArray(settings.riskAttributes)) return settings
  if (!settings.riskAttributes.some((attribute: any) => typeof attribute === "string")) return settings

  return {
    ...settings,
    riskAttributes: settings.riskAttributes
      .map((attribute: any) => (typeof attribute === "string" ? { id: attribute, name: attribute.trim() } : attribute))
      .filter((attribute: any) => attribute?.name)
  }
}

export const persistMigrations = {
  1: (state: any) => {
    if (!state) return state

    //Ne reecrit que les slices presentes : ajouter une cle a undefined ferait ecraser l'etat
    //initial du reducer par le reconciliateur de redux-persist.
    const migrated = { ...state }

    if (migrated._session) {
      migrated._session = {
        ...migrated._session,
        accountRisksSettings: migrateRiskAttributes(migrated._session.accountRisksSettings)
      }
    }

    if (migrated.account?.active) {
      migrated.account = {
        ...migrated.account,
        active: {
          ...migrated.account.active,
          accountRisksSettings: migrateRiskAttributes(migrated.account.active.accountRisksSettings)
        }
      }
    }

    return migrated
  },

  /**
   * v2 - Les enquetes RPS du compte vivent dans la slice account (account.rpsSurveys).
   * Le reconciliateur remplace la slice entiere par celle du localStorage : sans cette cle,
   * un navigateur deja ouvert lirait undefined la ou le code attend un tableau.
   */
  2: (state: any) => {
    if (!state?.account || Array.isArray(state.account.rpsSurveys)) return state

    return {
      ...state,
      account: {
        ...state.account,
        rpsSurveys: []
      }
    }
  }
}
